import {getQueryVariable} from "../utils/getQueryVariable";
import {client} from "./client";

export async function deactivateSelfRegistrationLink() {
  const publicId = getQueryVariable("r");

  await client.post(
    `/${process.env.REACT_APP_API_KEY}t179r/json/v2`,
    {
      parameters: {
        public_id: publicId,
      },
    },
    {
      headers: {
        Function: "DeactivateSelfRegistrationLink",
      },
    }
  );
}